import { createFeatureSelector, createSelector } from '@ngrx/store';

import { preferencesFeatureKey, State } from './preferences.reducer';

const selectPreferencesState = createFeatureSelector<State>(preferencesFeatureKey);

export const selectPreferencesByPolicy = createSelector(
  selectPreferencesState,
  state => state.preferencesByPolicy
);

export const selectUpdatingStatusAndError = createSelector(selectPreferencesState, state => ({
  updatingPolicies: state.updatingPolicies,
  error: state.error
}));

export const selectPreferenceOptionForPolicy = (policyId: string) =>
  createSelector(selectPreferencesByPolicy, preferencesByPolicy => {
    const preferences = preferencesByPolicy[policyId];
    if (preferences && preferences.length > 0) {
      const pref = preferences.find(
        p => p.businessContext === 'POLICY' && p.preferenceLabel === 'POLICY_DOCUMENT_DELIVERY'
      );
      return pref?.preferenceOption || 'EMAIL';
    }
    return 'EMAIL'; // Default to EMAIL if not found
  });

export const selectUserPreferencesByPolicy = (policyId: string) =>
  createSelector(selectPreferencesByPolicy, preferencesByPolicy => {
    const preferences = preferencesByPolicy[policyId];
    if (preferences && preferences.length > 0) {
      const pref = preferences.find(
        p => p.businessContext === 'POLICY' && p.preferenceLabel === 'POLICY_DOCUMENT_DELIVERY'
      );
      return pref;
    }
    return undefined; // Return undefined instead of empty object when not found
  });

// Helper selector to check if any preferences have been loaded
export const selectHasAnyPreferences = createSelector(
  selectPreferencesByPolicy,
  preferencesByPolicy => Object.keys(preferencesByPolicy).length > 0
);
